import { memo } from 'react';
import { ToastContainer } from 'react-toastify';

const ToastProvider = memo(() => {
  return (
    <ToastContainer
      hideProgressBar
      stacked
      position="top-center"
      autoClose={4000}
      bodyClassName="font-['Inter'] text-sm"
      toastClassName="rounded-btn"
    />
  );
});

ToastProvider.displayName = 'ToastProvider';

export default ToastProvider;
